import {
    fetchRentalAllPriceDetails,
    fetchRentalAllPriceDetailsByVendor
} from "../helper/perhitunganHarga.js";
import { tanggalIndo } from "../helper/formatTanggal.js";

function hitungHargaDenganPpn(harga) {
    const toggleSingle =
        document.getElementById("togglePpnPelayanan");

    const toggleMulti =
        document.getElementById("togglePpnPelayananMr");

    const aktif =
        toggleSingle?.checked ||
        toggleMulti?.checked;

    if (aktif) {
        return harga + (harga * 11 / 100);
    }

    return harga;
}

function hitungTotalHarga({
    hargaRental = 0,
    toll = 0,
    additional = 0
}) {

    const subtotal =
        Number(hargaRental) +
        Number(toll) +
        Number(additional);

    return hitungHargaDenganPpn(subtotal);
}

// Global state
let lastModalImage = null;
let lastModalName = "";
let lastModalCity = "";
let lastModalTanggalJemput = "";
let lastModalTanggalSelesai = "";

export function showModal(image, name, city, typeCarId, lat, lon, vendor) {
    const tabAktif = Alpine.store('tripTabsPelayanan').activeTab;

    let kotaJemput = "",
        kotaTujuan = "",
        destinasi = "",
        dalamKotaCode = 0,
        jarak = 0;

    let tanggalJemput = "";
    let tanggalSelesai = "";

    if (tabAktif === "tab1") {

        tanggalJemput =
            document.getElementById(
                "tanggalJemputPelayanan"
            )?.value;

        tanggalSelesai =
            document.getElementById(
                "tanggalSelesaiPelayanan"
            )?.value;

    } else {

        const range =
            document.getElementById(
                "tanggalRangePelayananMr"
            )?.value;

        if (range) {
            const [start, end] =
                range.split(" to ");

            tanggalJemput = start;
            tanggalSelesai = end;
        }
    }

    if (tabAktif === "tab1") {
        const inputJemput = document.getElementById("kotaPenjemputanPelayanan");
        const inputTujuan = document.getElementById("kotaTujuanPelayanan");
        const checkbox = document.getElementById("chkDalamKotaPelayanan");

        kotaJemput = inputJemput?.value.trim() || "";
        kotaTujuan = inputTujuan?.value.trim() || "";
        dalamKotaCode = checkbox?.checked ? 1 : 0;

        // Validasi
        if (dalamKotaCode === 1 && !kotaJemput) {
            Swal.fire({
                icon: "warning",
                title: "Kota penjemputan belum diisi",
                text: "Silakan isi kota penjemputan terlebih dahulu.",
                timer: 5000,
                timerProgressBar: true,
                showConfirmButton: false,
            });

            return;
        }

        if (dalamKotaCode === 0 && (!kotaJemput || !kotaTujuan)) {
            Swal.fire({
                icon: "warning",
                title: "Data belum lengkap",
                text: "Silakan pilih checklist Anda, apakah untuk dalam kota atau luar kota.",
                timer: 5000,
                timerProgressBar: true,
                showConfirmButton: false,
            });

            return;
        }

        if (dalamKotaCode === 0) {
            const elJarak = document.getElementById("outputJarakPelayanan");
            if (elJarak) {
                const match = elJarak.textContent.match(/[\d.]+/);
                jarak = match ? parseFloat(match[0]) : 0;
            }

            destinasi = kotaJemput + " - " + kotaTujuan;
        } else {
            destinasi = kotaJemput + " Dalam Kota";
            kotaTujuan = kotaJemput;
        }
    } else if (tabAktif === "tab2") {
        jarak = parseFloat(
            document.getElementById("outputJarakPelayananMr")
            .textContent.replace("km", "")
        ) || 0;
        destinasi = window.listKotaMultiTrip.join(" - ");
    }

    // Lanjutkan tampilkan modal
    const modal = document.getElementById("fullscreenModal");
    const modalContent = document.getElementById("modalContent");
    const modalImage = document.getElementById("modalImage");
    const modalName = document.getElementById("modalName");
    const modalCity = document.getElementById("modalCity");
    const modalDate = document.getElementById("modalDate");
    const modalDetail = document.getElementById("modalDetail");

    // Simpan state terakhir
    lastModalImage = image;
    lastModalName = name;
    lastModalCity = destinasi;
    lastModalTanggalJemput = tanggalJemput;
    lastModalTanggalSelesai = tanggalSelesai;

    // Isi tampilan awal modal
    modalImage.src = image;
    modalName.textContent = name;
    modalCity.textContent = destinasi + " ( Include Toll : " + formatRupiah(window.totalTolMultiTrip) + " )";
    modalDate.textContent = tanggalJemput + " - " + tanggalSelesai;
    modalDetail.innerHTML = '<p class="text-sm text-gray-500 italic">Memuat data...</p>';

    // Animasi masuk
    modal.classList.remove("hidden");
    modalContent.classList.remove("scale-100", "rotate-0", "opacity-100");
    modalContent.classList.add("scale-0", "rotate-[-12deg]", "opacity-0");

    [modalName, modalCity, modalDate].forEach((el) => {
        el?.classList.remove("opacity-100", "translate-y-0", "blur-0");
        el?.classList.add("opacity-0", "translate-y-2", "blur-sm");
    });

    setTimeout(() => {
        modalContent.classList.remove(
            "scale-0",
            "rotate-[-12deg]",
            "opacity-0"
        );
        modalContent.classList.add("scale-100", "rotate-0", "opacity-100");

        [modalName, modalCity, modalDate].forEach((el) => {
            el?.classList.remove("opacity-0", "translate-y-2", "blur-sm");
            el?.classList.add("opacity-100", "translate-y-0", "blur-0");
        });
    }, 50);

    loadCarsByCityAndCategories(
        city,
        kotaTujuan,
        destinasi,
        jarak,
        typeCarId,
        name,
        dalamKotaCode,
        lat,
        lon,
        vendor,
        tabAktif,
        tanggalJemput,
        tanggalSelesai
    );
}

function getAdditionalTotal(car = null) {

    let total = 0;

    const checkedItems = document.querySelectorAll(
        'input[name="cost[]"]:checked, input[name="costPelayanan[]"]:checked'
    );

    checkedItems.forEach((checkbox) => {

        const costId = Number(checkbox.value);

        switch (costId) {

            // BBM
            case 1:
                total += 100000;
                break;

            // Makan Driver
            case 2:
                total += Number(car?.meal_fee || 0);
                break;

            // Inap Driver
            case 3:
                total += Number(car?.lodging_fee || 0);
                break;

            default:

                const input = document.querySelector(
                    `[name="cost_amount[${costId}]"]`
                );

                total += Number(input?.value || 0);
        }
    });

    return total;
}

async function loadCarsByCityAndCategories(
    city,
    kotaTujuan,
    destinasi,
    jarak,
    typeCarId,
    name,
    dalamKotaCode,
    lat,
    lon,
    vendor,
    tabAktif,
    tanggalJemput,
    tanggalSelesai
){
    const modalDetail = document.getElementById("modalDetail");
    const spinner = document.getElementById("spinnerPelayanan");
    const loadingText = document.getElementById("loadingTextPelayanan");
    let result = [];
    modalDetail.innerHTML = "";
    spinner?.classList.remove("hidden");
    loadingText?.classList.remove("hidden");

    try {
        if (String(vendor) === "0")
        {
            if (tabAktif === "tab2") {
                const firstCoord = window.listKoordinatMultiTrip?.[0];
                if (firstCoord) {
                    lat = firstCoord.lat;
                    lon = firstCoord.lon;
                }
            }
            result = await fetchRentalAllPriceDetails({
                categoryId: typeCarId,
                lat,
                lon,
                city,
                kotaTujuan,
                destinasi,
                jarak,
                name,
                dalamKotaCode
            });

            modalDetail.innerHTML = result
            .map((company) => {
                return company.car_types
                    .map((car) => {
                        // let hargaRent = Number(car.total_harga);
                        // hargaRent = hitungHargaDenganPpn(hargaRent);
                        let hargaRental = Number(car.total_harga || 0);

                        let additional =
                            getAdditionalTotal();

                        let hargaRent = hitungTotalHarga({
                            hargaRental,

                            toll:
                                Number(window.totalTolMultiTrip || 0),
                            additional
                        });

                        const formatRupiah = (n) =>
                            "Rp " + Number(n).toLocaleString("id-ID");
                        return `
                            <div class="group cursor-pointer"
                                data-car-id="${car.car_type_id}"
                                data-car-name="${car.car_type_name}"
                                data-transmission="${car.transmission}"
                                data-year="${car.year}"
                                data-passenger_capacity="${car.passenger_capacity}"
                                data-companyId="${company.company_id}"
                                data-company="${company.company_name}"
                                data-phone="${company.phone}"
                                data-address="${company.address}"
                                data-tanggal="${tanggalJemput}"
                                data-city="${encodeURIComponent(city)}"
                                data-harga="${hargaRental}"
                                data-final-harga="${hargaRent}"
                                data-harga-awal="${hargaRental}"
                                data-additional="${Number(additional || 0)}"
                                data-image="${car.car_image}"
                                data-dalamKota="${dalamKotaCode}"
                                data-lat="${lat}"
                                data-lon="${lon}"
                                data-meal-fee="${car.meal_fee || 0}"
                                data-lodging-fee="${car.lodging_fee || 0}">

                                <div class="
                                        bg-white/80 backdrop-blur
                                        rounded-2xl
                                        border border-gray-200/60
                                        p-4
                                        flex gap-4
                                        transition-all duration-300 ease-out
                                        hover:shadow-xl hover:shadow-indigo-100/50
                                        hover:border-indigo-300/60
                                        hover:-translate-y-0.5
                                    "
                                >
                                    <div class="relative">
                                        <img
                                            src="${
                                                car.car_image ??
                                                "images/logo.png"
                                            }"
                                            class="
                                                w-16 h-16
                                                rounded-xl
                                                object-cover
                                                ring-1 ring-gray-200
                                                transition-transform duration-300
                                                group-hover:scale-105
                                            "
                                        />
                                    </div>

                                    <div class="flex-1 min-w-0">
                                        <h3
                                            class="
                                                font-semibold
                                                text-gray-800
                                                group-hover:text-indigo-600
                                                transition-colors
                                                truncate
                                            "
                                        >
                                            ${car.car_type_name}
                                        </h3>

                                        <p class="text-xs text-gray-500 mt-0.5 truncate">
                                            ${company.company_name}
                                        </p>

                                        <div class="flex items-center gap-3 mt-2 text-xs text-gray-500">
                                            <span class="flex items-center gap-1">
                                                ⚙️ ${car.transmission ?? "-"}
                                            </span>
                                            <span class="flex items-center gap-1">
                                                📆 ${car.year ?? "-"}
                                            </span>
                                            <span class="flex items-center gap-1 text-indigo-500 font-medium">
                                                📍 ${company.distance_km} km
                                            </span>
                                            <span class="text-indigo-600 font-semibold">
                                                💰 ${formatRupiah(
                                                    Number(hargaRent || 0)
                                                )}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        `;
                    })
                    .join("");
            })
            .join("");

            // bind click
            document.querySelectorAll("#modalDetail [data-car-id]")
            .forEach((el) => {
                el.addEventListener("click", () => {
                    showModalSubDetails(
                        decodeURIComponent(el.dataset.city),
                        el.dataset.carId,
                        destinasi,
                        el.dataset.carName,
                        el.dataset.transmission,
                        el.dataset.year,
                        el.dataset.passenger_capacity,
                        el.dataset.companyid,
                        el.dataset.company,
                        el.dataset.phone,
                        el.dataset.address,

                        Number(el.dataset.finalHarga),
                        Number(el.dataset.additional || 0),

                        Number(el.dataset.mealFee || 0),
                        Number(el.dataset.lodgingFee || 0),
                        el.dataset.tanggal,
                        document.getElementById("tanggalSelesaiPelayanan").value,
                        el.dataset.image,
                        kotaTujuan,
                        el.dataset.dalamkota,
                        el.dataset.lat,
                        el.dataset.lon,
                        tabAktif
                    );
                });
            });
        } else {
                result = await fetchRentalAllPriceDetailsByVendor({
                    vendorId: vendor,
                    categoryId: typeCarId,
                    tanggalJemput,
                    tanggalSelesai
                });

            modalDetail.innerHTML = result
            .map((company) => {
                return company.car_types
                    .map((car) => {
                        // let hargaRent = Number(car.total_harga);
                        // hargaRent = hitungHargaDenganPpn(hargaRent);
                        let hargaRental = Number(car.total_harga || 0);

                        let additional =
                            getAdditionalTotal(car);

                        let hargaRent = hitungTotalHarga({
                            hargaRental,

                            toll:
                                Number(window.totalTolMultiTrip || 0),
                            additional
                        });

                        const formatRupiah = (n) => "Rp " + Number(n).toLocaleString("id-ID");

                        return `
                            <div class="group cursor-pointer"
                                data-car-id="${car.car_type_id}"
                                data-car-name="${car.car_type_name}"
                                data-transmission="${car.transmission ?? "-"}"
                                data-year="${car.year ?? "-"}"
                                data-companyid="${company.company_id}"
                                data-company="${company.company_name}"
                                data-phone="${company.phone ?? ""}"
                                data-address="${company.address ?? ""}"
                                data-tanggal="${tanggalJemput}"
                                data-city="${encodeURIComponent(city)}"
                                data-harga="${hargaRental}"
                                data-final-harga="${hargaRent}"
                                data-harga-awal="${hargaRental}"
                                data-additional="${Number(additional || 0)}"
                                data-image="${car.car_image}"
                                data-dalamkota="${dalamKotaCode}"
                                data-lat="${company.latitude}"
                                data-lon="${company.longitude}"
                                data-meal-fee="${car.meal_fee || 0}"
                                data-lodging-fee="${car.lodging_fee || 0}">

                                <div class="
                                    bg-white/80 backdrop-blur
                                    rounded-2xl
                                    border border-gray-200/60
                                    p-4
                                    flex gap-4
                                    transition-all duration-300 ease-out
                                    hover:shadow-xl hover:shadow-indigo-100/50
                                    hover:border-indigo-300/60
                                    hover:-translate-y-0.5
                                ">
                                    <div class="relative">
                                        <img
                                            src="${car.car_image ?? "images/logo.png"}"
                                            class="
                                                w-16 h-16
                                                rounded-xl
                                                object-cover
                                                ring-1 ring-gray-200
                                                transition-transform duration-300
                                                group-hover:scale-105
                                            "
                                        />
                                    </div>

                                    <div class="flex-1 min-w-0">
                                        <h3 class="
                                            font-semibold
                                            text-gray-800
                                            group-hover:text-indigo-600
                                            transition-colors
                                            truncate
                                        ">
                                            ${car.car_type_name}
                                        </h3>

                                        <p class="text-xs text-gray-500 mt-0.5 truncate">
                                            ${company.company_name}
                                        </p>

                                        <div class="flex items-center gap-3 mt-2 text-xs text-gray-500">
                                            <span>⚙️ ${car.transmission ?? "-"}</span>
                                            <span>📆 ${car.year ?? "-"}</span>
                                            <span class="text-indigo-600 font-semibold">
                                                💰 ${formatRupiah(
                                                        Number(hargaRent || 0)
                                                )}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        `;
                    })
                    .join("");
            })
            .join("");

            document.querySelectorAll("#modalDetail [data-car-id]")
            .forEach((el) => {
                el.addEventListener("click", () => {
                    showModalSubDetails(
                        decodeURIComponent(el.dataset.city),
                        el.dataset.carId,
                        destinasi,
                        el.dataset.carName,
                        el.dataset.transmission,
                        el.dataset.year,
                        el.dataset.passenger_capacity,
                        el.dataset.companyid,
                        el.dataset.company,
                        el.dataset.phone,
                        el.dataset.address,
                        el.dataset.finalHarga,
                        el.dataset.additional,

                        Number(el.dataset.mealFee || 0),
                        Number(el.dataset.lodgingFee || 0),
                        el.dataset.tanggal,
                        tanggalSelesai,
                        el.dataset.image,
                        kotaTujuan,
                        el.dataset.dalamkota,
                        el.dataset.lat,
                        el.dataset.lon,
                        tabAktif
                    );
                });
            });
        }

        spinner?.classList.add("hidden");
        loadingText?.classList.add("hidden");

        // result SEKARANG ARRAY
        if (!Array.isArray(result) || result.length === 0) {
            modalDetail.innerHTML =
                '<p class="text-sm text-red-500 text-center">Mobil tidak tersedia.</p>';
            return;
        }

    } catch (err) {
        spinner?.classList.add("hidden");
        loadingText?.classList.add("hidden");
        modalDetail.innerHTML = '<p class="text-sm text-red-500 text-center">Terjadi kesalahan.</p>';
        console.error(err);
    }
}

export function closeModal() {
    const modal = document.getElementById("fullscreenModal");
    const modalContent = document.getElementById("modalContent");
    const modalName = document.getElementById("modalName");
    const modalCity = document.getElementById("modalCity");
    const modalDate = document.getElementById("modalDate");

    modalContent.classList.remove("scale-100", "rotate-0", "opacity-100");
    modalContent.classList.add("scale-0", "rotate-[-12deg]", "opacity-0");

    [modalName, modalCity, modalDate].forEach((el) => {
        el?.classList.remove("opacity-100", "translate-y-0", "blur-0");
        el?.classList.add("opacity-0", "translate-y-2", "blur-sm");
    });

    setTimeout(() => {
        modal.classList.add("hidden");
    }, 500);
}

export async function showModalSubDetails(
    city,
    carId,
    destinasi,
    carName,
    transmission,
    year,
    passengerCapacity,
    companyId,
    company,
    phone,
    address,
    price,
    additional,

    mealFee,
    lodgingFee,
    tanggalJemput,
    tanggalSelesai,
    image,
    kotaTujuan,
    dalamKotaCode,
    lat,
    lon,
    tabAktif
) {
    const modal = document.getElementById("fullscreenModalSubDetails");
    const modalContent = document.getElementById("modalContentSubDetails");
    const modalCar = document.getElementById("modalCarSubDetails");
    const modalTrasmission = document.getElementById("modalSpesifikasiSubDetails_1");
    const modalYear = document.getElementById("modalSpesifikasiSubDetails_2");
    const modalPassenger = document.getElementById("modalSpesifikasiSubDetails_3");
    const modalImage = document.getElementById("modalImageSubDetails");
    const modalName = document.getElementById("modalNameSubDetails");
    const modalCity = document.getElementById("modalCitySubDetails");
    const modalDate = document.getElementById("modalDateSubDetails");
    const modalHargaSubDetails = document.getElementById("modalHargaSubDetails");

    // =========================
    // HITUNG JARAK
    // =========================
    let jarak = 0;

    if (tabAktif === "tab1") {
        if (Number(dalamKotaCode) === 0) {
            const elJarak = document.getElementById("outputJarakPelayanan");
            jarak =
                parseFloat(elJarak?.textContent?.replace("km", "").trim()) || 0;
        }
    } else if (tabAktif === "tab2") {
        const elJarak = document.getElementById("outputJarakPelayananMr");
        jarak = parseFloat(elJarak?.textContent?.replace("km", "").trim()) || 0;
    }

    // =========================
    // HEADER MODAL
    // =========================
    modalCar.textContent = carName;
    modalImage.src = image && image !== "null" && image !== "" ? image : "/images/logo.png";
    modalName.textContent = company + " - " + carName;
    modalCity.textContent = destinasi + " ( Include Toll : " + formatRupiah(window.totalTolMultiTrip) + " )";
    modalDate.textContent = `${tanggalJemput} - ${tanggalSelesai}`;

    const latNum = parseFloat(lat);
    const lonNum = parseFloat(lon);
    const mapDiv = document.getElementById("modalMapIframe");

    if (!isNaN(latNum) && !isNaN(lonNum) && mapDiv) {
        if (mapDiv._leaflet_id) {
            mapDiv._leaflet_id = null;
        }

        // buat map Leaflet
        const map = L.map(mapDiv, { center: [latNum, lonNum], zoom: 15 });

        // tile layer OSM
        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution: "&copy; OpenStreetMap contributors",
        }).addTo(map);
        L.marker([latNum, lonNum]).addTo(map);
        setTimeout(() => {
            mapDiv.classList.remove("opacity-0", "translate-y-2", "blur-sm");
            mapDiv.classList.add("opacity-100", "translate-y-0", "blur-0");
        }, 300);
        setTimeout(() => map.invalidateSize(), 350);
    } else {
        console.warn("LAT/LON INVALID atau map div tidak ditemukan", {
            lat,
            lon,
            mapDiv,
        });
    }

    const lokasiEl = document.getElementById("lokasiRental");

    if (!isNaN(latNum) && !isNaN(lonNum) && lokasiEl) {
        fetch(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latNum}&lon=${lonNum}`
        )
            .then((res) => res.json())
            .then((data) => {
                if (data && data.display_name) {
                    lokasiEl.textContent = data.display_name;

                    // tampilkan dengan transition
                    lokasiEl.classList.remove(
                        "opacity-0",
                        "translate-y-2",
                        "blur-sm"
                    );
                    lokasiEl.classList.add(
                        "opacity-100",
                        "translate-y-0",
                        "blur-0"
                    );
                }
            })
            .catch((err) => {
                console.warn("Gagal mendapatkan lokasi:", err);
            });
    } else {
        console.warn("LAT/LON INVALID atau element lokasi tidak ditemukan", {
            latNum,
            lonNum,
            lokasiEl,
        });
    }

    modalTrasmission.textContent = transmission || "-";
    modalYear.textContent = year || "-";
    modalPassenger.textContent = `${passengerCapacity || "-"} orang`;

    // =========================
    // HARGA MODAL
    // =========================
    let totalHarga = Number(price || 0);

    const ppnAktif =
        document.getElementById("togglePpnPelayanan")?.checked ||
        document.getElementById("togglePpnPelayananMr")?.checked;

    modalHargaSubDetails.innerHTML = `
        <div class="flex flex-col">
            <span class="font-semibold">
                Total Harga : ${formatRupiah(totalHarga)}
            </span>

            ${
                ppnAktif
                    ? `
                    <span class="text-xs text-green-600 mt-1">
                        ✓ Harga sudah termasuk PPN 11%
                    </span>
                    `
                    : `
                    <span class="text-xs text-gray-500 mt-1">
                        Harga tidak termasuk PPN
                    </span>
                    `
            }
        </div>
    `;

    // =========================
    // ANIMASI MODAL
    // =========================
    [modalName, modalCity, modalDate, modalHargaSubDetails].forEach((el) => {
        el.classList.remove("opacity-0", "translate-y-2", "blur-sm");
        el.classList.add("opacity-100", "translate-y-0", "blur-0");
    });

    // =========================
    // TAMPILKAN MODAL
    // =========================
    modal.classList.remove("hidden");
    modalContent.classList.remove("scale-0", "rotate-[-12deg]", "opacity-0");
    modalContent.classList.add("scale-100", "rotate-0", "opacity-100");

    setTimeout(() => {
        bindBtnLanjutClick({
            city,
            carId,
            destinasi,
            carName,
            transmission,
            year,
            passengerCapacity,
            companyId,
            company,
            phone,
            address,
            price,
            finalHarga: totalHarga,
            additional,
            tanggalJemput,
            tanggalSelesai,
            image,
            kotaTujuan,
            dalamKotaCode,
            lat,
            lon,
        });
    }, 100);
}

export function closeModalSubDetails() {
    const subModal = document.getElementById("fullscreenModalSubDetails");
    const mainModal = document.getElementById("fullscreenModal");
    const modalDetail = document.getElementById("modalDetail");

    if (!subModal || !mainModal) return;

    // Tutup sub modal
    subModal.classList.add("hidden");

    // BALIKIN modal utama ke normal
    mainModal.classList.remove("opacity-50", "blur-sm", "pointer-events-none");

    // Pastikan konten detail benar-benar kelihatan
    if (modalDetail) {
        modalDetail.classList.remove(
            "hidden",
            "opacity-0",
            "translate-y-full",
            "translate-y-2",
            "blur-sm"
        );
        modalDetail.classList.add("opacity-100", "translate-y-0");
    }
}

let isBindLanjutClickAttached = false;
let checkoutData = null;

export function bindBtnLanjutClick(data) {
    checkoutData = data;
    const modal = document.getElementById("fullscreenModalCheckOut");
    const content = document.getElementById("modalContentCheckOut");
    const btnLanjut = document.getElementById("btnLanjutPemesanan");
    const lokasiText = document.getElementById("checkoutLokasi");
    const mapFrame = document.getElementById("checkoutMap");
    const spesifikasiInline = document.getElementById("checkoutSpesifikasiInline");
    const spesifikasiList = document.getElementById("checkoutSpesifikasi");

    if (!btnLanjut || !modal || !content) return;
    if (isBindLanjutClickAttached) return;
    isBindLanjutClickAttached = true;

    btnLanjut.addEventListener("click", () => {

    const additionalNow =
        Number(getAdditionalTotal() || 0);

        checkoutData.additional = additionalNow;
        checkoutData.additionalTotal = additionalNow;
        checkoutData.finalHarga = Number(checkoutData.price || 0);

        document.getElementById("checkoutTujuan").textContent = checkoutData?.destinasi || "-";
        document.getElementById("selectedCarId").value = checkoutData?.carId || "";
        document.getElementById("checkoutIdPerusahaan").textContent = checkoutData?.companyId || "-";
        document.getElementById("checkoutPerusahaan").textContent = checkoutData?.company || "-";
        document.getElementById("checkoutWA").textContent = checkoutData?.phone || "-";
        document.getElementById("checkoutAlamat").textContent = checkoutData?.address || "-";
        document.getElementById("checkoutMobil").textContent = checkoutData?.carName || "-";
        document.getElementById("checkoutTanggal").textContent = checkoutData?.tanggalJemput && checkoutData?.tanggalSelesai
                ? `${tanggalIndo(checkoutData.tanggalJemput)} - ${tanggalIndo(checkoutData.tanggalSelesai)}`
                : "-";
        // document.getElementById("checkoutTotal").textContent = formatRupiah(parseFloat(checkoutData?.price || 0));

        let totalCheckout =
            Number(checkoutData?.finalHarga || checkoutData?.price) || 0;

        checkoutData.additionalTotal =
            Number(checkoutData.additional || 0);

        checkoutData.tollTotal =
            Number(window.totalTolMultiTrip || 0);

        document.getElementById("checkoutTotal").textContent =
            formatRupiah(totalCheckout);

        const spesifikasiUtama = [
            { icon: "fas fa-cogs", value: checkoutData?.transmission || "-" },
            { icon: "fas fa-calendar-alt", value: checkoutData?.year || "-" },
            { icon: "fas fa-users", value: `${checkoutData?.passengerCapacity || "-"} orang`,
            },
        ];

        if (spesifikasiInline) {
            spesifikasiInline.innerHTML = spesifikasiUtama
                .map(
                    (item) => `
                        <span class="inline-flex items-center gap-1 px-2 py-1 bg-gray-100 rounded-full shadow-sm text-[12px]">
                            <i class="${item.icon} text-indigo-500 text-xs"></i>
                            ${item.value}
                        </span>
                    `
                )
                .join("");
        }

        if (spesifikasiList) {
            spesifikasiList.innerHTML = `
            <div class="flex items-start gap-2">
                <i class="fas fa-map-marker-alt text-blue-500 mt-[2px] w-4"></i>
                <span class="text-[13px] text-gray-700">
                    ${checkoutData?.city || "-"}
                </span>
            </div>
        `;
        }

        if (lokasiText && mapFrame && checkoutData?.lat && checkoutData?.lon) {
            lokasiText.textContent = `Lokasi Rental: ${checkoutData.city}`;
            mapFrame.src = `https://www.google.com/maps?q=${checkoutData.lat},${checkoutData.lon}&output=embed`;
        }

        modal.classList.remove("hidden");
        setTimeout(() => {
            content.classList.remove("scale-0", "rotate-[-12deg]", "opacity-0");
            content.classList.add("scale-100", "rotate-0", "opacity-100");
        }, 10);
    });
}

export function closeModalCheckOut() {
    const modal = document.getElementById("fullscreenModalCheckOut");
    const content = document.getElementById("modalContentCheckOut");

    if (!modal || !content) return;

    // Tambah animasi keluar
    content.classList.remove("scale-100", "rotate-0", "opacity-100");
    content.classList.add("scale-0", "rotate-[-12deg]", "opacity-0");

    // Reset Alpine.js step dan paymentMethod jika ada
    if (modal.__x) {
        modal.__x.$data.step = 0;
        modal.__x.$data.paymentMethod = "dp";
    }

    // Reset elemen teks
    const resetText = [
        "checkoutPerusahaan",
        "checkoutWA",
        "checkoutAlamat",
        "checkoutTanggal",
        "checkoutMobil",
        "checkoutTotal",
        "checkoutLokasi",
    ];
    resetText.forEach((id) => {
        const el = document.getElementById(id);
        if (el) el.textContent = "-";
    });

    // Reset spesifikasi
    const spesifikasiInline = document.getElementById(
        "checkoutSpesifikasiInline"
    );
    if (spesifikasiInline) spesifikasiInline.innerHTML = "";

    const spesifikasiList = document.getElementById("checkoutSpesifikasi");
    if (spesifikasiList) spesifikasiList.innerHTML = "";

    // Reset input tanggal
    const tanggalMundur = document.getElementById("tanggalMundur");
    if (tanggalMundur) tanggalMundur.value = "";

    // Reset Google Map
    const mapFrame = document.getElementById("checkoutMap");
    if (mapFrame) {
        mapFrame.src = "";
        mapFrame.classList.remove("opacity-100", "translate-y-0", "blur-0");
        mapFrame.classList.add("opacity-0", "scale-95", "blur-sm");
    }

    // Reset variabel global jika ada
    if (typeof lastModalImage !== "undefined") lastModalImage = null;
    if (typeof lastModalName !== "undefined") lastModalName = "";
    if (typeof lastModalCity !== "undefined") lastModalCity = "";
    if (typeof lastModalTanggalJemput !== "undefined")
        lastModalTanggalJemput = "";
    if (typeof lastModalTanggalSelesai !== "undefined")
        lastModalTanggalSelesai = "";

    // Reset class content agar siap buka ulang
    setTimeout(() => {
        modal.classList.add("hidden");

        // Pastikan class modal content kembali ke posisi awal
        content.classList.remove("scale-0", "rotate-[-12deg]", "opacity-0");
        content.classList.add("scale-100", "rotate-0", "opacity-100");
    }, 500);
}

function formatRupiah(angka) {
    return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
    }).format(angka);
}

function resetCheckout() {
    const spesifikasiInline = document.getElementById(
        "checkoutSpesifikasiInline"
    );
    const spesifikasiList = document.getElementById("checkoutSpesifikasi");
    const mapFrame = document.getElementById("checkoutMap");

    const textIds = [
        "checkoutTujuan",
        "checkoutPerusahaan",
        "checkoutWA",
        "checkoutAlamat",
        "checkoutMobil",
        "checkoutTanggal",
        "checkoutTotal",
        "checkoutLokasi",
    ];

    textIds.forEach((id) => {
        const el = document.getElementById(id);
        if (el) el.textContent = "-";
    });

    const selectedCar = document.getElementById("selectedCarId");
    if (selectedCar) selectedCar.value = "";

    // Reset spesifikasi
    if (spesifikasiInline) spesifikasiInline.innerHTML = "";
    if (spesifikasiList) spesifikasiList.innerHTML = "";

    // Reset map
    if (mapFrame) {
        mapFrame.src = "";
        mapFrame.classList.add("opacity-0", "translate-y-2", "blur-sm");
        mapFrame.classList.remove("opacity-100", "translate-y-0", "blur-0");
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const togglePpn = document.getElementById("togglePpnPelayanan");

    if (togglePpn) {
        togglePpn.addEventListener("change", () => {

            const modal = document.getElementById("fullscreenModal");

            if (!modal.classList.contains("hidden")) {
                modal.querySelectorAll("[data-car-id]").forEach((item) => {
                    item.click();
                });
            }
        });
    }
});
